import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

import { currentDevice } from '../../../core/utils/currentDevice'
import { getPrefix } from '../../../core/utils/locale.js'
import { closeLoader, openLoader } from '../../../elements/wait_loading/wait_loading'
import MainHeader from '../../../layout/header/header.js'
import { createAndShowHtmlSheet } from '../../../shared/bottom_sheet/bottom_sheet.js'
import fastbooking from '../../../shared/fastbooking/ibh_fastbooking'
import Modal from '../../../shared/modal/modal'
import { isDebugConsoleEnabled } from '../../../utils/debug.js'
import on from '../../../utils/events_delegation.js'
import { getLazyData } from '../../../utils/get_lazy_data'
import { cloneJson } from '../../../utils/utilities'
import { init as initMap } from '../../poi_map_packed/poi_map'

import { initializeCtaUtagEvents } from './hotel_card_info_modal.analitycs.js'

const BLOCK_NAME = 'hotel_card_info_modal'
const TABS = {
  INFO: 'information',
  RATINGS: 'ratings',
}
const hotelsWithVisitedInfoTab = new Set()
const TAB_TRIGGER_SELECTOR = '.js-hotel-card-info-tab'
const TAB_CONTENT_SELECTOR = '.js-hotel-card-info-tab-content'
const RATINGS_IFRAME_SELECTOR = '.js-hotel-card-info-modal-reviews'
const RATINGS_IFRAME_URL_SELECTOR = '[data-ratings-iframe-url]'
const isBookingsPage = document.URL.includes('reservas') || document.URL.includes('bookings')

const defaultState = {
  modalTrigger: null,
  modal: null,
  tabContents: null,
  currentTab: TABS.INFO,
  hotelId: null,
  infoModalContent: null,
  isRatingsIframeInitialized: false,
  isInfoContentInitialized: false,
  informationContentSwiper: null,
  backtoInfoTabCta: null,
}
let state = {
  ...defaultState,
}

// --- TAB SWITCH ---
function beforeTabOpening(tab) {
  if (!tab || !state.modal || !state.tabContents || !state.tabContents.length) return

  if (tab === TABS.RATINGS && !state.isRatingsIframeInitialized) {
    const ratingsIframe = state.modal.querySelector(RATINGS_IFRAME_SELECTOR)

    if (ratingsIframe) {
      ratingsIframe.src = state.ratingsUrl
      state.isRatingsIframeInitialized = true
    }
  } else if (tab === TABS.INFO && !state.isInfoContentInitialized) {
    initInformationModal()
    state.isInfoContentInitialized = true
  }

  // hide back to info cta in info tab
  if (state.backtoInfoTabCta) {
    const hasVisitedInfoForThisHotel = hotelsWithVisitedInfoTab.has(state.hotelId)
    const shouldShowBackButton = tab === TABS.RATINGS && hasVisitedInfoForThisHotel

    state.backtoInfoTabCta.classList.toggle('is-hidden', !shouldShowBackButton)
  }
}

function setTab(tab) {
  if (!tab) return

  if (!Object.values(TABS).includes(tab)) {
    // eslint-disable-next-line no-console
    isDebugConsoleEnabled && console.warn(`${BLOCK_NAME}: '${tab}' is not a valid tab.`)
    return
  }

  if (!state.modal || !state.tabContents || !state.tabContents.length) return

  state.currentTab = tab
  if (tab === TABS.INFO && state.hotelId) {
    hotelsWithVisitedInfoTab.add(state.hotelId)
  }
  beforeTabOpening(tab)

  let tabToShow
  // hide all tabs
  state.tabContents.forEach(tabContent => {
    tabContent.classList.add('is-hidden')

    if (tabContent.dataset.tabContent === tab) {
      tabToShow = tabContent
    }
  })
  // show active tab
  tabToShow.classList.remove('is-hidden')
  state.modal.querySelector('.js-tripadvisor').classList.toggle('is-ratings-modal', state.currentTab === TABS.RATINGS)
}

on({
  eventName: 'click',
  selector: TAB_TRIGGER_SELECTOR,
  handler(e) {
    const newTab = e.target.dataset.showTab
      ? e.target.dataset.showTab
      : e.target.closest(TAB_TRIGGER_SELECTOR).dataset.showTab

    if (!newTab) return

    setTab(newTab)
  },
})
function truncable(modal) {
  const elementTruncableModal = Array.from(modal.querySelectorAll('.js-is-truncable'))

  // Throwing "truncable" duplicates the js-link-see-more click event.
  // The element is cloned, as cloning does not clone events.
  const linksMoreContent = Array.from(modal.querySelectorAll('.js-link-see-more'))
  linksMoreContent.forEach(element => {
    const elementClone = element.cloneNode(true)
    element.parentNode.replaceChild(elementClone, element)
  })

  IB.truncable.init(elementTruncableModal)
}
function newSwiper() {
  if (state.informationContentSwiper) return
  const swiperContainer = `.js-album-container .js-swiper-default`
  const container = document.querySelector(swiperContainer)
  const swiperPagination = container.querySelector(':scope > .js-swiper-pagination')
  const swiperNavigationNext = container.querySelector(':scope > .js-swiper-button-next')
  const swiperNavigationPrev = container.querySelector(':scope > .js-swiper-button-prev')

  Swiper.use([Navigation, Pagination])
  state.informationContentSwiper = new Swiper(swiperContainer, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    pagination: {
      el: swiperPagination,
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 3,
    },
    navigation: {
      nextEl: swiperNavigationNext,
      prevEl: swiperNavigationPrev,
    },
    lazyPreloadPrevNext: 1,
  })
}

function handleBookHotel(hotelId) {
  fastbooking.setDestination(hotelId)

  if (!currentDevice.isMobile) {
    MainHeader.openPanel()
  } else {
    fastbooking.openStickyFastbooking()
  }

  fastbooking.openDates()
}

function addDatasToModal(modal, infoCardForModal) {
  const modalPrice = modal.querySelector('.js-hotel-info-card-price')
  if (!modalPrice) {
    return
  }
  const priceSpan = document.createElement('span')
  modalPrice.append(priceSpan)
  modalPrice.dataset.price = infoCardForModal.hotelPrice.price_value
  modalPrice.dataset.basePrice = infoCardForModal.hotelPrice.base_price_value
  if (isBookingsPage) {
    modalPrice.setAttribute('href', infoCardForModal.linkUrl)
  }
  modalPrice.dataset.residentPrice = infoCardForModal.hotelPrice.resident_price_value
  modalPrice.dataset.currency = infoCardForModal.hotelPrice.currency
  modalPrice.dataset.promoCode = infoCardForModal.hotelPrice.promocode
  priceSpan.innerHTML = infoCardForModal.hotelRealPrice
}

function initInformationModal() {
  if (!state.modal) return

  const utag_info = cloneJson(utag_data)

  utag_info['page_url'] = ''
  utag_info['page_name'] = utag_info['page_url'].replace(`${window.location.protocol}//${window.location.host}`, '')
  utag_info['page_pathname'] = ''

  newSwiper()
  initMap(state.hotelId, true)
}

function destroy() {
  if (state.informationContentSwiper) {
    state.informationContentSwiper.destroy()
  }
}

function modificarHTML(sheet) {
  const sheetBody = sheet.querySelector('.js-sheet-body')
  const footer = sheet.querySelector('.js-modal-footer')

  if (sheetBody && footer) {
    sheetBody.parentNode.insertBefore(footer, sheetBody.nextSibling)
  }
}

function initializeModalActionButtons(modalElement, infoCardForModal, closeAction) {
  const chooseBtn = modalElement.querySelector('.js-choose-text')
  const bookNowBtn = modalElement.querySelector('.js-book-now-text')

  if (isBookingsPage) {
    if (chooseBtn) {
      chooseBtn.classList.add('hidden')
    }
    if (bookNowBtn) {
      bookNowBtn.classList.remove('hidden')
    }
  } else {
    if (chooseBtn) {
      chooseBtn.classList.remove('hidden')
    }
    if (bookNowBtn) {
      bookNowBtn.classList.add('hidden')
    }
  }

  if (bookNowBtn && infoCardForModal && infoCardForModal.linkUrl) {
    bookNowBtn.setAttribute('href', infoCardForModal.linkUrl)
  }

  modalElement.querySelectorAll('.js-book-btn').forEach(cta => {
    cta.addEventListener('click', () => {
      if (typeof closeAction === 'function') {
        closeAction()
      }
      ScrollLock.off()

      if (isBookingsPage) {
        const targetHref = cta.dataset.href || cta.getAttribute('href')
        if (targetHref) {
          window.location.href = targetHref
        }
      } else {
        setTimeout(() => {
          handleBookHotel(cta.dataset.hotelId)
        }, 550)
      }
      initializeCtaUtagEvents()
    })
  })
}

function openHotelCardInfo() {
  if (!state.hotelId) return

  const utag_product_list_raw = 'hotel-list'
  const utag_product_list = utag_product_list_raw.replace(/\s/g, '-')

  const url = `${window.location.origin + getPrefix()}/ajax_contents/hotel/${state.hotelId}?show_reviews=&utag_page_url=&utag_position=&up=&upl=${utag_product_list}&nfh=`

  const infoCardForModal = state.infoModalContent === undefined ? '' : state.infoModalContent

  openLoader()
  getLazyData(url, function (modalHtml) {
    closeLoader()
    if (currentDevice.isMobile) {
      createAndShowHtmlSheet({
        html: modalHtml,
        sheetHeight: 100,
        sheetClass: 'js-hotel-card-info',
        onShow: (sheet, sheetInstance) => {
          ScrollLock.on()

          state.modal = sheet
          modificarHTML(sheet)
          sheet.querySelector('.js-sheet-content').classList.remove('padding')

          state.tabContents = sheet.querySelectorAll(TAB_CONTENT_SELECTOR)
          state.ratingsUrl = sheet.querySelector(RATINGS_IFRAME_URL_SELECTOR)?.dataset.ratingsIframeUrl || ''
          state.backtoInfoTabCta = sheet.querySelector('.js-back-to-info-tab')
          const sheetText = sheet.querySelector('.js-hotel-info-card-text')

          if (infoCardForModal) {
            sheetText.innerHTML = infoCardForModal.hotelCardText
            addDatasToModal(state.modal, infoCardForModal)
          }

          setTab(state.currentTab)
          truncable(state.modal)
          initializeModalActionButtons(state.modal, infoCardForModal, () => sheetInstance.close())
          IB.currencyForm.forceUpdate()
        },
        onClose: () => {
          ScrollLock.off()
          destroy()
        },
      })
    } else {
      Modal.showHtml({
        html: modalHtml,
        hasContentPadding: false,
        modalClass: 'hotel-card-info-modal-container',
        onShow: modal => {
          ScrollLock.on()

          state.modal = modal
          state.tabContents = modal.querySelectorAll(TAB_CONTENT_SELECTOR)
          state.ratingsUrl = modal.querySelector(RATINGS_IFRAME_URL_SELECTOR)?.dataset.ratingsIframeUrl || ''
          state.backtoInfoTabCta = modal.querySelector('.js-back-to-info-tab')
          const modalText = modal.querySelector('.js-hotel-info-card-text')

          if (infoCardForModal) {
            modalText.innerHTML = infoCardForModal.hotelCardText
            addDatasToModal(state.modal, infoCardForModal)
          } else {
            modal.querySelector('.js-hotel-info-card-tax-info').classList.add('hidden')
          }

          setTab(state.currentTab)
          truncable(state.modal)
          initializeModalActionButtons(state.modal, infoCardForModal, Modal.closeAll)
        },
        onClose: () => {
          ScrollLock.off()
          destroy()
        },
        awaitCloseAnimation: true,
      })
    }
  })
}

export function initModal({ element, contentToShow = TABS.INFO, hotelId, infoModalContent }) {
  if (!hotelId) {
    // eslint-disable-next-line no-console
    isDebugConsoleEnabled && console.warn(`${BLOCK_NAME}: 'hotelId' is required`)
    return
  }

  state = {
    ...defaultState,
    hotelId,
    infoModalContent,
  }

  if (!Object.values(TABS).includes(contentToShow)) {
    // eslint-disable-next-line no-console
    isDebugConsoleEnabled &&
      console.warn(`${BLOCK_NAME}: '${contentToShow}' is not valid content. Showing ${TABS.INFO} as default`)
    state.currentTab = TABS.INFO
  } else {
    state.currentTab = contentToShow
  }

  if (!hotelId) {
    // eslint-disable-next-line no-console
    isDebugConsoleEnabled && console.warn(`${BLOCK_NAME}: 'hotelId' is required`)
    return
  }

  state.modalTrigger = element

  openHotelCardInfo()
}
